import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { sendData } from "../../services/auth";
import { uriList } from "../../helpers/config";

const ModaleditOS = (props) => {
    const [osid, setOsID] = useState('')
    const [loading, setLoading] = useState(false)

    const handleSubmit = async() => {
        await sendData({ uri: uriList("updateosid"),content: { osid,id : props.item.id }  })
        .then((res) => {
            if (res.status === 200) {
                props.onClose()
            }
        })
        .catch(error => {
            console.log(error);
        })
    }

    useEffect(() => {
        setOsID(props.item?.osid || '')
    },[props])

    return (
        <>
            <Modal show={props.show} size="md" aria-labelledby="contained-modal-title-vcenter" centered onHide={() => props.onClose()}>
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <i className="fa fa-user-pen" /> Edição de OSID
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{width:"220px", height:"100px"}}>
                    <div>
                        <label>OSID</label>
                        <input type="text" className='form-control' value={osid} onChange={e => setOsID(e.target.value)}/>
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ padding: "3px", }}>
                    <div style={{ flexDirection: "initial", display: 'flex', justifyContent: "flex-start", gap:"5px" }}>
                        <div className={loading ? 'hidden-display' : ''} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button onClick={handleSubmit} variant="success" style={{ width: "100px" }}><i className="fa fa-save" /> Gravar</Button>
                        </div>
                        <Button type="button" style={{ width: "100px" }} onClick={e => props.onClose()}><i className="fa fa-window-close" /> Sair</Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};


export default ModaleditOS;